module.exports = __webpack_public_path__ + "ca16e2dcec6b5211e63a42357bff6d98.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-flag-kit/assets/QA.svg
// module id = AaeZ
// module chunks = 0